import { render, staticRenderFns } from "./WorkingDeveloperIcon.vue?vue&type=template&id=54af87b4&scoped=true&"
import script from "./WorkingDeveloperIcon.vue?vue&type=script&lang=js&"
export * from "./WorkingDeveloperIcon.vue?vue&type=script&lang=js&"
import style0 from "./WorkingDeveloperIcon.vue?vue&type=style&index=0&id=54af87b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54af87b4",
  null
  
)

export default component.exports